import { Component } from '@angular/core';
import { PoliticaTermoService } from 'app/resources/services/politica-termo.service';

@Component({
  selector: 'app-politica-termo',
  templateUrl: './politica-termo.component.html',
  styleUrls: ['./politica-termo.component.css']
})
export class PoliticaTermoComponent {

  public readonly RAZAO_SOCIAL = 'APOIO AO CLIENTE';
  // public readonly CNPJ_EMPRESA = '44.097.674/0001-21';
  public readonly NOME_FANTASIA = 'APOIO AO CLIENTE';
  public readonly DATA_ULTIMA_ATUALIZACAO_POLITICA = '25/08/2022';
  public readonly DATA_ULTIMA_ATUALIZACAO_TERMO = '25/08/2022';
  public readonly EMAIL_LGPD = 'administrativo@apoiocliente.com.br';
  public readonly EMAIL_CONTATO = 'sac@apoiocliente.com.br';
  // public readonly NOME_APLICATIVO = 'Full';

  constructor(public politicaTermoService: PoliticaTermoService) {}

}



// WEBPACK FOOTER //
// ./src/app/politica-termo/politica-termo.component.ts